import { render } from "./SVGHooksLeft.vue?vue&type=template&id=776c933e"
const script = {}

import exportComponent from "/home/tachyon/wardrobe-test3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__